<template>
    <div>
        <div><i class="material-icons">textsms</i></div>
        <h3>SMS-påminnelse kunde:</h3>

        <div>
            <textarea placeholder="Sms text" v-model="sms_text" rows="6"></textarea>
            <span class="v-error" v-if="localErrors.sms_text" v-text="localErrors.sms_text"></span>
        </div>
        <div>
            <input @keyup.enter="send()" v-model="phone_number" placeholder="Phone number (12345678)" type="text"/>
            <span class="v-error" v-if="localErrors.phone_number" v-text="localErrors.phone_number"></span>
        </div>
        <div>
            <button @click.prevent="send()">Send</button>
        </div>
    </div>
</template>

<script>

import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components

export default {
  data () {
    return {
        phone_number: null,
        sms_text: null,
        id_request: null,
        validate: false
    }
  },
  mixins: [VuejsDialogMixin],
  computed: {
      localErrors(){
          if(this.validate){
              var e = {};
              if(!this.phone_number.match(/^\d{8}$/ig))
                  e.phone_number = 'Mobilnummer må fylles ut (8 siffer)';
              if(!this.sms_text)
                  e.sms_text = 'Sms text is empty';
              return e;
          }else{
              return {};
          }
      }
  },
  methods: {
      send(){
        this.validate = true;
        if(!this.validateSms()) return;
        this.proceed({
            phone_number: this.phone_number,
            sms_text: this.sms_text,
            id_request: this.id_request
        });
      },
      validateSms(){
          this.validate = true;

          if(Object.keys(this.localErrors).length)
              return false;

          return true;
      },
  },
  created(){
      if(this.messageBody) {
          let data = JSON.parse(this.messageBody);
          this.phone_number = data.phone_number
          this.sms_text = data.sms_text
          this.id_request = data.id_request
      }
  }
}
</script>

<style lang="scss">
    .v-error{
        color: red;
        text-align: right;
        font-size: 12px;
    }
</style>


// WEBPACK FOOTER //
// SmsDialog.vue?48b11720